try {
// Grant-support panels (budget justification, letter of support, phased delivery) open in an overlay (#panelModal in
// lys-v4-bottom) instead of expanding at the bottom of the section. The hidden .copy-box is moved into the modal while
// open and put back on close, so its ids and Copy buttons keep working. Handles data-panel-toggle and data-copy-toggle.
(function(){
  var modal = document.getElementById('panelModal'), body = document.getElementById('panelModalBody');
  if (!modal || !body) return;
  var current = null, home = null, trigger = null;
  function close(){
    if (!current) return;
    current.hidden = true;
    home.parent.insertBefore(current, home.next);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    current = null; home = null; trigger = null;
    modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
  }
  function open(btn, id){
    var box = document.getElementById(id); if (!box) return;
    close();
    home = { parent: box.parentNode, next: box.nextSibling }; current = box; trigger = btn;
    body.appendChild(box); box.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    var c = modal.querySelector('.gate-close'); if (c) c.focus();
  }
  [].forEach.call(document.querySelectorAll('[data-panel-toggle],[data-copy-toggle]'), function(b){
    b.addEventListener('click', function(){ open(b, b.getAttribute('data-panel-toggle') || b.getAttribute('data-copy-toggle')); });
  });
  [].forEach.call(modal.querySelectorAll('[data-panel-close]'), function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
})();
} catch (e) { console.error("lys-v4 panel-toggle", e); }
